<template>
  <div class="content-page data-goods" @click="robotConfigVisible = true">
    <div class="bd">
      <div class="tab-content">
        <div style="margin-bottom: 20px">
          <el-date-picker
            v-model="dateTime"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateTimeChange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <span style="padding: 0 10px 0 40px; box-sizing: border-box">排序</span>
          <el-select size="small" v-model="sortOrder" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span style="padding: 0 10px 0 40px; box-sizing: border-box">订单状态</span>
          <el-select size="small" v-model="orderStatus" placeholder="请选择">
            <el-option
              v-for="item in orderType"
              :key="item.orderStatus"
              :label="item.orderStatusName"
              :value="item.orderStatus"
            >
            </el-option>
          </el-select>
          <span style="padding: 0 10px 0 40px; box-sizing: border-box">商品分类</span>
          <el-cascader
            v-model="menuSelCascaderValue"
            :options="categoryCascaderOptions"
            :props="categoryCascaderProps"
            size="small"
            placeholder="请选择商品分类"
            clearable
            filterable
            @change="menuSelChange"
          ></el-cascader>
          <span style="padding: 0 10px 0 20px; box-sizing: border-box">
            <el-button type="primary" size="small" @click="search">搜索</el-button>
          </span>
          <el-button type="primary" size="small" @click="exportTopGoods"
            >商品分析导出</el-button
          >
        </div>
        <div class="content-container">
          <el-table
            :data="goodsData"
            highlight-current-row
            @current-change="handleCurrentChange"
            style="width: 100%"
          >
            <el-table-column property="goodsName" label="商品信息"></el-table-column>
            <el-table-column property="saleNum" label="已售"></el-table-column>
            <el-table-column
              property="totalStockCount"
              label="库存剩余"
            ></el-table-column>
            <el-table-column property="index" label="排名"></el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findTopGoods,
  findTopGoodsListCount,
  getEdcShopGoodsCategorys,
  exportTopGoods,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  getCategoryIdFromCascader,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
} from "@/utils/secondaryCategory";
import request from "@/utils/request";
export default {
  data() {
    return {
      goodsData: [],
      pageNo: 1,
      pageSize: 10,
      pageCount: 0,
      dateTime: [],
      startTime: "",
      endTime: "",
      sortOrder: "",
      options1: [
        { value: "asc", label: "升" },
        { value: "desc", label: "降" },
      ],
      orderStatus: "",
      orderType: [
        {
          orderStatusName: "全部订单",
          orderNum: 0,
          orderStatus: "",
        },
        {
          orderStatusName: "未付款",
          orderNum: 0,
          orderStatus: 10,
        },
        {
          orderStatusName: "待接单",
          orderNum: 0,
          orderStatus: 19,
        },
        {
          orderStatusName: "待发货",
          orderNum: 0,
          orderStatus: 20,
        },
        {
          orderStatusName: "待确认",
          orderNum: 0,
          orderStatus: 30,
        },
        {
          orderStatusName: "待买单",
          orderNum: 0,
          orderStatus: 31,
        },
        {
          orderStatusName: "待评论",
          orderNum: 0,
          orderStatus: 35,
        },
        {
          orderStatusName: "已完成",
          orderNum: 0,
          orderStatus: 40,
        },
        {
          orderStatusName: "申请退款",
          orderNum: 0,
          orderStatus: -21,
        },
      ],
      menuSel: "",
      menuSelCascaderValue: [],
      menuList: [],
      categoryCascaderOptions: [],
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth() ||
              date.getFullYear() > new Date(time).getFullYear() ||
              date.getFullYear() < new Date(time).getFullYear()
            );
          } else {
            return false;
          }
        },
      },
    };
  },
  computed: {
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
  },
  mounted() {
    var day1 = new Date();
    day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
    var yesterday =
      day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
    // console.log(yesterday, "yesterday")
    var day2 = new Date();
    day2.setTime(day2.getTime());
    var today = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
    // console.log(today, "today")
    this.startTime = `${yesterday} 00:00:00`;
    this.endTime = `${today} 23:59:59`;
    this.dateTime = [this.startTime, this.endTime];
    // console.log(this.startTime, this.endTime)
    this.getPageData();
    this.getEdcShopGoodsCategorys();
  },
  methods: {
    menuSelChange(val) {
      this.menuSel = getCategoryIdFromCascader(val);
    },
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(node, resolve, 1000);
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          this.categoryCascaderOptions = toCategoryCascaderOptions(res.data);
        }
      });
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    getPageData() {
      this.findTopGoods();
      this.findTopGoodsListCount();
    },
    exportTopGoods() {
      location.href = `${request.baseUrl}/edcmanageapi/Goods_exportTopGoods?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}&pageNo=${this.pageNo}&row=${this.pageSize}&startTime=${this.startTime}&endTime=${this.endTime}&orderBy=saleNum&sortOrder=${this.sortOrder}&orderStatus=${this.orderStatus}&goodsCategoryId=${this.menuSel}`;
      // exportTopGoods({
      //   pageNo: this.pageNo,
      //   row: this.pageSize,
      //   startTime: this.startTime,
      //   endTime: this.endTime,
      //   orderBy: "saleNum",
      //   sortOrder: this.sortOrder,
      //   orderStatus: this.orderStatus,
      //   goodsCategoryId: this.menuSel,
      // });
    },
    findTopGoods() {
      findTopGoods({
        pageNo: this.pageNo,
        row: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime,
        orderBy: "saleNum",
        sortOrder: this.sortOrder,
        orderStatus: this.orderStatus,
        goodsCategoryId: this.menuSel,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val, index) => {
            val.monthlySales = val.monthlySales || 0;
            val.index = index + 1 + this.pageSize * (this.pageNo - 1);
          });
          this.goodsData = res.data;
        } else if (res.code == -1) {
          this.goodsData = [];
        } else {
        }
      });
    },
    findTopGoodsListCount() {
      findTopGoodsListCount({
        pageNo: this.pageNo,
        row: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime,
        orderBy: "saleNum",
        sortOrder: this.sortOrder,
        orderStatus: this.orderStatus,
        goodsCategoryId: this.menuSel,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.findTopGoods();
    },
    search() {
      this.findTopGoods();
      this.findTopGoodsListCount();
    },
    dateTimeChange(date) {
      console.log(date);
      if (!date) {
        this.findTopGoods();
        this.findTopGoodsListCount();
        return;
      }
      this.startTime = date[0];
      this.endTime = date[1];
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: auto;
  .bd {
    height: 100%;
  }
  .tab-content {
    display: block;
    padding: 20px 20px 0;
    height: 100%;
  }
}
</style>

<style lang="less">
.data-goods {
  .el-table__body-wrapper {
    font-weight: bold;
  }
}
</style>
